import classnames from 'classnames';
import { uniqWith } from 'lodash';
import React, { useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Input } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { LOCAL_STORAGE_MATERIAL } from '@/types';
import './search.less';

interface ISearchProps {
    keyword: string;
    setKeyword: (str: string) => void;
    setClassType: (str: string) => void;
}
export interface SearchRef {
    setSearchKey: (key: string) => void;
}
const Search = React.forwardRef<SearchRef, ISearchProps>(({ keyword, setKeyword, setClassType }, ref) => {
    const { $t } = useLocaleStore();
    const [inputValue, setInputValue] = useState('');
    const refInput = useRef<any>(null);
    const [isInputFocus, setIsInputFocus] = useState<boolean>(false);

    const trimValue = useMemo(() => inputValue.trim(), [inputValue]);

    useImperativeHandle(ref, () => ({
        setSearchKey: (newKey: string) => {
            setInputValue(newKey);
        },
    }));

    const clearKeyword = () => {
        setInputValue('');
        setKeyword('');
        refInput.current.focus();
    };

    const saveHistory = () => {
        // 保存历史记录
        const tagList: string[] = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_MATERIAL) as string) || [];
        tagList.unshift(inputValue);
        window.localStorage.setItem(LOCAL_STORAGE_MATERIAL, JSON.stringify(uniqWith(tagList)));
    };

    const inputFocus = () => {
        setIsInputFocus(true);
    };
    const inputBlur = () => {
        setIsInputFocus(false);
    };

    const keywordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { target } = e;
        const { value } = target;
        setInputValue(value);
        if (value.trim() === trimValue) return;
    };

    const handleSearch = () => {
        if (trimValue === keyword) {
            return;
        }
        if (trimValue !== '') {
            saveHistory();
        }
        setInputValue(trimValue);
        setKeyword(trimValue);
        setClassType('clumn');
    };
    return (
        <div className="app-collapse-material__header">
            <div
                className={classnames('search-container', {
                    'search-container-active': isInputFocus,
                })}
            >
                <div className="search">
                    <span className="search-icon">
                        <IconFont name="SearchBold" fontSize={16} onClick={handleSearch} />
                    </span>
                    <span className="search-close">
                        {keyword || inputValue ? (
                            <IconFont name="CrossCircleFillBold" fontSize={16} onClick={clearKeyword} />
                        ) : null}
                    </span>
                    <Input
                        ref={refInput}
                        onChange={keywordChange}
                        onFocus={inputFocus}
                        onPressEnter={handleSearch}
                        value={inputValue}
                        onBlur={inputBlur}
                        placeholder={$t((v) => v.collapse.materialCollapse.searchPlaceholder)}
                        className={classnames({
                            active: inputValue.length,
                        })}
                    />
                </div>
            </div>
        </div>
    );
});
export default React.memo(Search);
